import DataBalance from "../components/message-components/data-balance.component";
import OutstandingAmount from '../components/message-components/outstanding-amount.component'
import MonthlyPlan from '../components/message-components/monthly_plan.component'
import IrRecommendedPacks from '../components/message-components/ir-packs-components/ir-recommended-packs.component'
import PlanRental from "../components/message-components/plan-rental.component";
import { ChatResponse } from "../components/message-components/chat-response.component";
import userResponseComponent from "../components/message-components/user-response.component";
import HistoryDate from "../components/message-components/history-date.component"
import ComponentTypes from '../enums/ComponentTypes'
import loggedInWelcomeComponent from '../components/message-components/loggedInWelcome.component'
import DuplicateBills from '../components/message-components/duplicate-bills.component'
import PaymentReceipts from '../components/message-components/payment-receipts.component'
import DeactivateIrPack from "../components/message-components/deactivate-ir-pack.component";
import switchAccountMessageComponent from '../components/message-components/switch-account-message.component'

const chooseComponentToRender = ({ message, handleUserAction, showPopup, hide_logo, firstTimeMultiple = false, setBottomBarToInput, showNumbersToSwitchBot }) => {


    switch (message.component_type) {
        case ComponentTypes.DEFAULT:
            return ChatResponse({ ...message, hide_logo });

        case ComponentTypes.CURRENT_BILL_PLAN:
            return PlanRental(message);

        case ComponentTypes.DATA_BALANCE:
            return DataBalance(message);

        case ComponentTypes.OUTSTANDING:
            return OutstandingAmount(message);

        case ComponentTypes.MONTHLY_PLAN:
            return MonthlyPlan({ ...message, handleUserAction, showPopup });

        case ComponentTypes.IR_PACK:
            return IrRecommendedPacks(message, setBottomBarToInput, showPopup, handleUserAction);

        case ComponentTypes.USER_RESPONSE:
            return userResponseComponent(message);

        case ComponentTypes.LOGIN_COMPONENT:
            return ChatResponse(message);

        case ComponentTypes.HISTORY_DATE_COMPONENT:
            return HistoryDate(message);

        case ComponentTypes.WELCOME_COMPONENT_MULTIPLE: {
            return loggedInWelcomeComponent({ firstTimeMultiple, ...message, hide_logo })
        }
        case ComponentTypes.PREV_DUPLICATE_BILLS: {
            return DuplicateBills({ ...message, showPopup });
        }
        case ComponentTypes.PREV_PAYMENT_RECEIPTS: {
            return PaymentReceipts({ ...message, showPopup })
        }
        case ComponentTypes.IR_PACK_DEACTIVATION: {
            return DeactivateIrPack({ ...message, showPopup, handleUserAction, setBottomBarToInput })
        }
        case ComponentTypes.SWITCH_ACCOUNT_MESSAGE: {
            return switchAccountMessageComponent({ ...message, showNumbersToSwitchBot })
        }
        default:
            return ChatResponse(message);

    }

}

export default { chooseComponentToRender }


// WEBPACK FOOTER //
// ./src/services/chooseComponentToRender.service.js